import React from 'react';
import RecordByTypeItem from './RecordByTypeItem';
import { useLocation } from 'react-router-dom';
import useGlobalMobileConfigs from '@/stores/globalConfigsMobile';
import dayjs from 'dayjs';
import NoDataYet from '@/components/NoDataYet';
interface Props {
  rawData: Array<IEMRData>;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
}

const HeathRecordTabList = ({ rawData, isFetchingNextPage, fetchNextPage }: Props) => {
  const location = useLocation();
  const { emrTypeCode } = location?.state;
  const emrTypes = useGlobalMobileConfigs((s) => s.emrTypes);
  const extraFunction = emrTypes?.[emrTypeCode].extraFunction ? Function(emrTypes?.[emrTypeCode].extraFunction)() : {};

  const renderItem = (i: IEMRData) => {
    return (
      <RecordByTypeItem key={i._id} data={i} rowFn={extraFunction?.mobile?.rowFn} emrType={emrTypes?.[emrTypeCode]} />
    );
  };

  const groupHrByDay: Record<string, IEMRData[]> = React.useMemo(() => {
    return (
      rawData?.reduce((d: any, e) => {
        const day = dayjs(e.date);
        d[day.format('DD/MM/YYYY')] = d[day.format('DD/MM/YYYY')] ? [...d[day.format('DD/MM/YYYY')], e] : [e];
        return d;
      }, {}) || {}
    );
  }, [rawData]);

  return (
    <>
      <div
        className={`overflow-y-auto pt-2 h-[calc(100vh-120px)] pb-[68px]`}
        onScroll={(e) => {
          const element: any = e.target;
          const { scrollTop, clientHeight, scrollHeight } = element;
          if (scrollTop + clientHeight >= scrollHeight - 50) {
            !isFetchingNextPage && fetchNextPage();
          }
        }}
      >
        {Object.values(groupHrByDay).length ? (
          Object.values(groupHrByDay)?.map((rows, i) => {
            const day = dayjs(rows[0].date);
            return (
              <div key={i.toString()} className="flex flex-col">
                {/*  ngày */}
                <span className="cms-body2 ml-1  px-6 mt-3 mb-2">
                  {day.isSame(dayjs(), 'day') ? 'Hôm nay, ' : ''}
                  {day.format('DD/MM/YYYY')}
                </span>
                {rows?.map(renderItem)}
              </div>
            );
          })
        ) : (
          <NoDataYet />
        )}
      </div>
    </>
  );
};

export default HeathRecordTabList;
